define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"src/c8-platform/service/aggregateStoreService",
	"src/c8-platform/type/value",
	"csi",
	"csi/action/ActionView",
	"csi/action/Controller",
	"csi/comm",
	"csi/def",
	"csi/locale",
	"csi/reflection",
	"csi/reflectionHints",
	"csi/session",
	"csi/service/viewService",
	"csi/state/viewUtils",
	"csi/xml"
], function(array, declare, {clearAggregateStoreResponsesByNodeType}, {isMapValueType}, csi, ActionView, Controller, comm, def, locale, reflection, reflectionHints, session, {shouldUseReactForm}, {isReactView}, xml) {

	var AUTHTYPE = "AuthType";
	return declare(Controller, {
		// Boolean: indicate that user should land on new node after node is created
		bNavigate: false,

		// Boolean: do we need to update the parent node?
		bUpdateParent: true,

		// Boolean: do we need to validate the new node?
		bValidate: true,

		// String: attribute id used for key for mapped relationships
		//idQualifier: null,

		// Attribute: relationship from parent to new node
		relation: null,

		// String: next sibling if inserting into ordered list
		m_urlBefore: null,

		// ChangeNode: change operation for newly created node that will be added to its container
		m_cnNew: null,

		// String: give option to change the saave button localization
		saveResourceId: "Save",

		constructor: function(/*Object*/params) {
			// store type separate from action in case it is abstract and need to pick concrete one;
			// type may also be determined by source node if creating from template or library
			this.m_typeNode = this.m_action.m_typeNode;

			// New action should always have correct parent context and no node context (even if in table actions column)
			this.m_urlNode = null;

			this.useReactForm = shouldUseReactForm(this.m_typeNode);
		},

		getActionNodeType: function() {
			// summary: return the type of the node the controller is acting upon
			return this.m_typeNode;
		},

		getStringParameters: function() {
			return [locale.type(this.m_typeNode)];
		},

		/** Not need for the new React form */
		getActionView: function(/*ViewRef?*/vr) {
			// summary: search for view using type of node being created before looking in other places
			if (!this.m_action.m_viewRef) return null;

			var a = this.m_action;
			var idView = a.m_viewRef.m_id;
			var rc = reflection.getClass(this.m_typeNode);
			var defView = def.getClassViewDef(rc, idView);

			// check base type for view if not found in derived type
			if (!defView && a.m_typeNode && (this.m_typeNode != a.m_typeNode)) {
				rc = reflection.getClass(a.m_typeNode);
				defView = def.getClassViewDef(rc, idView);
			}

			// create view if found
			if (defView) {
				return new ActionView(this, defView);
			}

			// do not lookup in the context of current container if it's an automatically generated view;
			// otherwise use default behavior
			return (idView == def.DEFAULT_FORM_ID) ? null : this.inherited(arguments);
		},

		/** Not need for the new React form */
		getFormData: function() {
			// summary: indicate form creating new node
			var data = this.inherited(arguments);
			data.m_node = null;
			return data;
		},

		/** Not need for the new React form */
		addProxyActions: function(/*View*/defView, /*Actions*/defActions) {
			// summary: if creating new node, then add Save & New action as well
			if (isReactView(defView)) {
				return;
			}

			if (this._canNavigate()) {
				defActions.addAction(this.getProxyAction("Save_Go", true));
			}

			if (this._canRepeat()) {
				defActions.addAction(this.getProxyAction("Save_New", true, {m_bRepeat: true}));
			}

			defActions.addAction(this.getProxyAction(this.saveResourceId, true, {m_bSubmit: true}));
			this.inherited(arguments);
		},

		/** Not need for the new React form */
		preProcess: function() {
			// summary: preprocessing
			this.relation = reflection.getRelation(this.getParent(), this.m_idAttrParent);

			// make sure navigation is allowed even if hard-coded to true - this is needed for new actions
			// that arise in popup views
			if (this.bNavigate && !this._canNavigate()) {
				this.bNavigate = false;
			}

			this.inherited(arguments);
		},

		_canNavigate: function() {
			// summary: indicate if this action supports navigation to new node (Save & Go)
			return def.canNavigateToType(this.m_typeNode) && !this.widget.bPopup;
		},

		/**
		 * (Save & New) is hidden on the new action from the views.
		 */
		_canRepeat: function() {
			const fd = this.widget.defView.m_formData;
			if (fd != null && fd.m_bSelectOne) {
				return false;
			}

			// Indicate if this action supports repeat operations (Save & New)
			return !this.bPreventRepeat && !this.widget.defView.idContentView && (!this.relation || xml.attributeTypeIsContainer(this.relation.getType()));
		},

		/** Not need for the new React form */
		createNewUrl: function() {
			return comm.createUrl();
		},

		/**
		 * Extension point for specifying form info
		 * @param {IForm} formInfo
		 */
		onCreateFormInfo(formInfo) { },

		process: function() {
			// create new node
			var call = this.toWriter();
			var w = this.m_writer;

			// add node to parent if not using server request (call)
			if (!call && this.relation && this.bUpdateParent) {
				var typeAttr = this.relation.getType();
				var bAttach;
				var value;

				if (xml.attributeTypeIsContainer(typeAttr)) {
					if (this.m_urlBefore) {
						// only makes sense to insert into ordered list
						var children = this.getParent()[this.m_idAttrParent];
						if (children && children.length) {
							var n = array.indexOf(children, this.m_urlBefore);
							if (n >= 0) {
								value = csi.objectNew(n, this.m_urlNode);
								w.changeNode(this.m_urlParent).changeAttributeKeys(this.m_idAttrParent, typeAttr, value, true);
							}
						}
					}

					if (!value) {
						// append new node
						if (this.idQualifier) {
							// get qualifier from form
							value = {};
							value[this.m_formData.getFieldValue(this.idQualifier) || ""] = this.m_urlNode;
							w.changeParent(this.m_urlParent, this.m_idAttrParent, typeAttr, value, true);
						} else {
							bAttach = true;
						}
					}
				} else {
					bAttach = true;
				}

				if (bAttach) {
					var cn = this.m_cnNew || w.changeNode(this.m_urlNode);
					cn.attach(this.m_urlParent, this.m_idAttrParent);
				}
			}

			// call the validation method on the server
			if (w.isChanged() && this.bValidate) {
				this.validateNode(this.m_urlNode, true);
			}

			this.publish();
		},

		toWriterReactForm() {
			return Controller.prototype.toWriter.call(this);
		},

		toWriter: function() {
			// summary: write operations to create new node

			if (this.useReactForm) {
				return this.toWriterReactForm();
			}

			var call = null;

			this.m_urlNode = this.createNewUrl();
			if (!this.m_urlNode) throw new Error('URLCREATE');

			if (this.m_typeNode == xml.TYPE_USER) {
				var idUser = this.m_formData.getFieldValue(xml.PROP_USERID, true);

				this.m_cnNew = this.m_writer.createUser(idUser, this.m_urlNode);

				// manually move email up to the initial CreateUser element (TODO: fix this generally C8-3616)
				this.m_cnNew.changeAttribute(xml.PROP_EMAIL, xml.ATTR_STRING, this.m_formData.getFieldValue(xml.PROP_EMAIL, true))
					.changeAttributeFlag(xml.PROP_EMAIL, xml.ATTR_FLAG_MODIFIED_BY_CLIENT, true);
				this.m_cnNew.changeAttribute(AUTHTYPE, xml.ATTR_REF, this.m_formData.getFieldValue(AUTHTYPE, true))
					.changeAttributeFlag(AUTHTYPE, xml.ATTR_FLAG_MODIFIED_BY_CLIENT, true);
			} else {
				call = this.inherited(arguments);

				if (call) {
					// add request parameters specific to NewFrom
					call.addParameter(xml.PROP_TYPE, xml.ATTR_STRING, this.m_typeNode);

					if (this.m_urlBefore && !xml.isClientUrl(this.m_urlBefore)) {
						call.addParameter(xml.PROP_URL_BEFORE, xml.ATTR_REF, this.m_urlBefore);
					}
				} else {
					// create node using simple operation
					this.m_cnNew = this.m_writer.createNode(this.m_urlNode, this.m_typeNode);
				}
			}

			// write out fields from form (if any)
			this.toWriterFields(this.m_urlNode);

			// call type-specific OnAction function
			this._onAction(call);

			return call;
		},

		getReturnNodeRequest: function(/*String[]*/urlsNew) {
			// summary: add new url to request - return nothing if navigating to new node in which case another view will handle request
			if (xml.isValidURL(this.m_urlNode)) {
				urlsNew.push(this.m_urlNode);
			}

			return this.inherited(arguments);
		},

		/** Not need for the new React form */
		postProcessProxy: function(/*Boolean*/bStatus) {
			// summary: if action was success and is to be repeated (Save & New), reset node to null
			this.inherited(arguments);

			if (bStatus) {
				this.m_urlNode = null;
			}
		},

		postProcessSuccess: function() {
			// summary: navigate to new node if so specified - make sure to close popup dialog if in one
			if (this.bNavigate) {
				var dlg = this.getDialog();
				if (dlg) {
					dlg.hide();
				}

				// find node to navigate to - could have browse mapping
				// C8-9568
				// add ability for controller to override destination URL
				var navNodeURL = this._getNavigateNodeURL();
				if (navNodeURL) {
					session.setLocationUrl(navNodeURL, true, true);
					return null;
				}
			}

			return this.inherited(arguments);
		},

		/**
		 * Retrieve the target Navigation URL when postProcessSuccess() completes
		 *
		 * This method returns the URL to the node that was created in the postProcessSuccess() call, unless
		 * it is determined that a link to the node is not allowed
		 *
		 * This function can be overridden by subclass to allow navigation to a URL that is not otherwise noted
		 *
		 * C8-9568
		 *
		 * @return {String} URL of node to navigate to, or null if none
		 */
		_getNavigateNodeURL: function() {
			const node = this.getNode();
			return reflectionHints.canLinkToNode(node) ? node.$URL : null;
		},

		/** Not need for the new React form */
		/**
		 * @override
		 * Specify form info
		 */
		_onCreatePopupParams(viewParams) {
			const {m_typeNode, m_urlParent, relation} = this;
			const formInfo = viewParams.formInfo = {
				// nodeUrl: <eventually specify new url here rather than create in form, but beware of Save & New>
				nodeType: m_typeNode,
			}

			if (relation?.isComposite) {
				formInfo.parentAttributeId = relation.getId();
				formInfo.parentUrl = m_urlParent;

				if (isMapValueType(relation.valueType)) {
					// this is not currently being used to set the actual key to use, but rather just in aggregate store ReportOperations to
					// attach the new node to its parent just to be compliant
					formInfo.parentAttributeKey = "__New__";
				}
			} else {
				formInfo.contextAttributeId = relation?.getId();
				formInfo.contextUrl = m_urlParent;
			}

			this.onCreateFormInfo(formInfo);
			this.inherited(arguments);
		},

		/**
		 * @override
		 * Clear aggregate store cache of responses that contain results of the new node type
		 */
		_onPublishResponse(response) {
			if (this.m_typeNode) {
				clearAggregateStoreResponsesByNodeType(this.m_typeNode);
			}

			this.inherited(arguments);
		},

		_setRefNode: function(/*DOMNode*/refNode) {
			// summary: set refNode before which the new item will be inserted
			if (refNode) {
				this.m_urlBefore = this.widget.getRefNodeUrl(refNode);
			}

			this.inherited(arguments);
		}
	});
});